module.exports = __webpack_public_path__ + "static/star-94f1448fd8c61d04c7198d43ad126450.svg";